import { useEffect, useRef, useState } from "react";
import { getEmploymentHistoryPSRpreview } from "../../../../../api/makeAPIRequest";
import { getFilteredAddData } from "../helpers";
import "./steps.scss";
import moment from "moment";

const tableHeaders = {
  TITLE: "Title",
  COMP_NAME: "Company Name",
  START_DATE: "Start Date",
  END_DATE: "End Date",
};

const desc = {
  PPR: "Personal Production Record(s)",
  PSR: "Personal Sales Record(s)",
};

function StepFourPSRConfirmation({
  oktaSubId,
  state,
  handlePsrCheckboxChange,
  hasNYRegs,
}) {
  const isMounted = useRef(false);
  const [psrData, setPsrData] = useState([]);
  const [deletedPsrData, setDeletedPsrData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const formatDate = (date) => {
    return `${moment(date).utc().format("MM/DD/YYYY")}`;
  };

  const fetchPreviewPSR = async () => {
    try {
      setIsLoading(true);

      const data = await getFilteredAddData(state);

      const psrResponse = await getEmploymentHistoryPSRpreview(
        oktaSubId,
        state.id,
        data
      );

      const yearlyPreview = psrResponse.yearlyPreview || [];
      const deletedPSRs = psrResponse.deletedPSRs || [];

      setPsrData(yearlyPreview);
      setDeletedPsrData(deletedPSRs);
      setIsLoading(false);

      isMounted.current = false;
    } catch (err) {
      setIsLoading(false);
      isMounted.current = false;
      if (err) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    isMounted.current = true;

    if (isMounted.current) {
      fetchPreviewPSR();
    }

    return () => {
      isMounted.current = false;
      window.onbeforeunload = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="add-employment-history-modal-step-4">
      <br />
      {isLoading ? (
        <div />
      ) : (
        deletedPsrData.length > 0 && (
          <>
            <div
              className="row"
              style={{ marginTop: "10px", marginBottom: "10px" }}
            >
              <div className="col-md-12">
                <strong>
                  Due to the Employment History update, the following{" "}
                  {hasNYRegs ? desc.PPR : desc.PSR} will be deleted.
                </strong>
                <br />
                <br />
              </div>
            </div>
            <div className="psr-table-wrapper">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>{tableHeaders.TITLE}</th>
                    <th>{tableHeaders.COMP_NAME}</th>
                    <th>{tableHeaders.START_DATE}</th>
                    <th>{tableHeaders.END_DATE}</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedPsrData.map((item, index) => (
                    <tr key={index}>
                      <td className="wrap-cell">{item.jobtitle}</td>
                      <td className="wrap-cell">{item.companyname}</td>
                      <td>{formatDate(item.startdate)}</td>
                      <td>
                        {formatDate(item.enddate) === formatDate(new Date()) ||
                        item.enddate === null
                          ? "Present"
                          : formatDate(item.enddate)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )
      )}

      {isLoading ? (
        <div
          className="mm-dots-loading"
          style={{ float: "right", marginTop: "3px" }}
        />
      ) : (
        <>
          <div
            className="row"
            style={{ marginTop: "10px", marginBottom: "10px" }}
          >
            <div className="col-md-12">
              {deletedPsrData.length > 0 && <br />}
              <strong>
                Due to the Employment History update, please review your{" "}
                {hasNYRegs ? desc.PPR : desc.PSR}.
              </strong>
              <br />
              <br />
            </div>
          </div>
          <div className="psr-table-wrapper">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>{tableHeaders.TITLE}</th>
                  <th>{tableHeaders.COMP_NAME}</th>
                  <th>{tableHeaders.START_DATE}</th>
                  <th>{tableHeaders.END_DATE}</th>
                </tr>
              </thead>
              <tbody>
                {psrData?.length ? (
                  psrData?.map((item, index) => (
                    <tr key={index}>
                      <td className="wrap-cell">{item.jobtitle}</td>
                      <td className="wrap-cell">{item.companyname}</td>
                      <td>{formatDate(item.startdate)}</td>
                      <td>
                        {formatDate(item.enddate) === formatDate(new Date()) ||
                        item.enddate === null
                          ? "Present"
                          : formatDate(item.enddate)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr key={1}>
                    <td colSpan={4}>No {hasNYRegs ? "PPR" : "PSR"} data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      <div className="row">
        <div className="col-md-12">
          <br />
          <i>Please confirm below:</i>
          <br />
          <br />
          <label htmlFor="psrCheckbox">
            <input
              type="checkbox"
              id="psrCheckbox"
              checked={state.psrCheckbox}
              onChange={handlePsrCheckboxChange}
              style={{ marginRight: "5px" }}
            />
            <span>I confirm these changes *</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default StepFourPSRConfirmation;
